import * as React from 'react';
import { JSX } from 'react/jsx-runtime';
const AccordianMinusIcon = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => (
  <svg
    width={19}
    height={2}
    viewBox="0 0 19 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.27441 1H9.45572H17.637"
      stroke="#004E9B"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default AccordianMinusIcon;
